import { dataConsumer } from '@atlaskit/adf-schema';
export var dataConsumerPlugin = function dataConsumerPlugin() {
  return {
    name: 'dataConsumer',
    marks: function marks() {
      return [{
        name: 'dataConsumer',
        mark: dataConsumer
      }];
    }
  };
};